import React from 'react';
import { Box } from '@mui/material';

interface PropsType {
  children: React.ReactNode;
}

const BasicBox = ({ children }: PropsType) => {
  return (
    <Box
      sx={{
        backgroundColor: '#201f1f',
        color: '#eee',
      }}
    >
      {children}
    </Box>
  );
};

export default BasicBox;
